import { Briefcase } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createRoleFilterConfig(): FilterStringConfig {
  return {
    label: 'Role',
    icon: <Briefcase />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' })
  };
}
